import _ from 'lodash'
import Vue from 'vue'
import StringFormat from '@/utils/StringFormat'
import { mapState } from 'vuex'
import LineChart from '@/components/common/Result/ResultDetail/ResultChart/LineChart/LineChart'
import MixedChart from '@/components/common/Result/ResultDetail/ResultChart/MixedChart/MixedChart'
import chartOptionUtil from '@/store/result/utils/chartoption'
import { ClientTable } from 'vue-tables-2'
import VueScrollTo from 'vue-scrollto'
import VueHighcharts from 'vue2-highcharts'
import CustomPagination from '@/components/common/CustomPagination/CustomPagination'

export default {
  name: 'ResultDetail',
  props: {
    headerFlag: Boolean,
    mailFlag: Boolean,
    headers: Array,
    vtColumns: Array,
    vtOptions: Object,
    items: Array,
    analyzeTargetCode: String,
    graphSetting: Number,
    historyId: Number,
    activeTab: String,
    isListLoading: Boolean
  },
  components: {
    VueHighcharts: VueHighcharts,
    LineChart: LineChart,
    MixedChart: MixedChart,
    CustomPagination: CustomPagination
  },
  computed: {
    ...mapState('chartdata', {
      chartOptions: state => _.cloneDeep(state.chartOptions),
      tabType: state => state.tabType,
      if00025Info: state => state.if00025Info
    }),
    ...mapState('analyzeresult', {
      analyze_raw_count: state => state.historyData.analyze_raw_count
    }),
    showChart () {
      if (this.chartOptions.length > 0) {
        return chartOptionUtil.hasChartByTabs(this.analyzeTargetCode, this.tabType)
      }
      return false
    },
    showMultiChart () {
      if (this.chartOptions.length > 0) {
        if (this.analyzeTargetCode === 'IF00002') {
          return true
        }
      }
      return false
    },
    showIF00025Chart () {
      return this.analyzeTargetCode === 'IF00025' && !_.isEmpty(this.if00025Info)
    },
    exportItems () {
      if (this.analyze_raw_count > 1000000) {
        return [
          { type: 1, title: 'CSV' }
        ]
      } else {
        return [
          { type: 1, title: 'CSV' },
          { type: 2, title: 'Excel' }
        ]
      }
    },
    yAxisList () {
      if (this.analyzeTargetCode === 'IF00010') {
        return chartOptionUtil.IF00010YAXIS()
      } else if (this.analyzeTargetCode === 'IF00003') {
        return chartOptionUtil.IF00003YAXIS()
      } else if (this.analyzeTargetCode === 'IF00011') {
        return chartOptionUtil.IF00011YAXIS()
      }
    }
  },
  data: () => ({
    headerNeed: true,
    mailNeed: false,
    yAxis: '',
    currentPage: 1
  }),
  watch: {
    mailNeed () {
      this.$emit('update:mailFlag', this.mailNeed)
    },
    headerNeed () {
      this.$emit('update:headerFlag', this.headerNeed)
    },
    items () {
      // Re-sync scrollbars when table data changes
      this.$nextTick(() => {
        this.initScrollbars()
      })
    }
  },
  created () {
    Vue.use(ClientTable)

    if (this.analyzeTargetCode === 'IF00010') {
      this.yAxis = 'base_purchase_qty'
    } else if (this.analyzeTargetCode === 'IF00003') {
      this.yAxis = 'purchase_qty_composition_rate_card'
    } else if (this.analyzeTargetCode === 'IF00011') {
      this.yAxis = 'base_purchase_qty_composition_rate'
    }
  },
  mounted () {
    this.initScrollbars()
  },
  updated () {
    this.initScrollbars()
  },
  destroyed () {
    // Clean up event listeners
    const topScrollbar = this.$refs.topScrollbar
    const bottomScrollbar = this.$refs.bottomScrollbar
    if (topScrollbar && bottomScrollbar) {
      topScrollbar.removeEventListener('scroll', this.onScroll)
      bottomScrollbar.removeEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    initScrollbars () {
      this.$nextTick(() => {
        const topScrollbar = this.$refs.topScrollbar
        const bottomScrollbar = this.$refs.bottomScrollbar

        if (topScrollbar && bottomScrollbar) {
          this.syncScrollbarWidths()
          topScrollbar.removeEventListener('scroll', this.onScroll) // Prevent duplicate listeners
          bottomScrollbar.removeEventListener('scroll', this.onScroll)
          topScrollbar.addEventListener('scroll', this.onScroll)
          bottomScrollbar.addEventListener('scroll', this.onScroll)
        }
      })
    },
    syncScrollbarWidths () {
      const topScrollbar = this.$refs.topScrollbar
      const bottomScrollbar = this.$refs.bottomScrollbar
      const clientTable = this.$refs.clientTable

      if (topScrollbar && bottomScrollbar && clientTable) {
        const tableEl = clientTable.$el
        if (tableEl) {
          const tableWidth = tableEl.scrollWidth
          topScrollbar.querySelector('.c-top-scrollbar-content').style.width = `${tableWidth}px`
        }
      }
    },
    onScroll (e) {
      const topScrollbar = this.$refs.topScrollbar
      const bottomScrollbar = this.$refs.bottomScrollbar
      if (e.target === topScrollbar) {
        bottomScrollbar.scrollLeft = e.target.scrollLeft
      } else {
        topScrollbar.scrollLeft = e.target.scrollLeft
      }
    },
    exportReport (type) {
      this.$emit('onExportReport', type)
    },
    onPagination (pagination) {
      this.$emit('onPagination', pagination)
    },
    redrawChart (value) {
      this.$emit('onRedrawChart', value)
    },
    vtFormatString (n, type) {
      // if (!n) {
      //   if (type === 'int') return '0'
      //   if (type === 'float') return '0'
      //   if (type === 'percent') return '0'
      //   return n
      // }
      if (type === 'percent') {
        // n = n - 0
        // n = StringFormat.nFormat(n * 100, 2, true, 0)
        // n = Math.round(n * 10000) / 100
        if (n === null) {
          return ''
        }
        n = n * 100
        n = n.toFixed(2)
        n = n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else if (type === 'float') {
        // n = n - 0
        // n = StringFormat.nFormat(n, 2, true, 0)
        // n = Math.round(n * 100) / 100
        if (n === null) {
          return ''
        }
        n = n.toFixed(2)
        n = n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else if (type === 'int') {
        // n = n - 0
        // n = StringFormat.nFormat(n, 0, true, 0)
        // n = Math.round(n)
        if (n === null) {
          return ''
        }
        if (n === '') {
          return ''
        }
        if (!Number.isFinite(n - 0)) {
          n = 0
        } else {
          n = n - 0
          n = n.toFixed(0)
          n = n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        }
      }
      return n
    },
    onVtPagination (data) {
      this.$nextTick(() => {
        VueScrollTo.scrollTo('#vue-table-scroll-to', 300,
          {
            offset: -100,
            easing: 'ease-out'
          }
        )
      })
    },
    showYList () {
      return _.includes(['IF00003', 'IF00010', 'IF00011'], this.analyzeTargetCode) && this.showChart
    },
    getLegend (cd, defaultName) {
      return chartOptionUtil.getLegend(cd, defaultName)
    },
    handlePageChange (page) {
      this.currentPage = page
      if (this.$refs.clientTable) {
        this.$refs.clientTable.setPage(page)
      }
    }
  },
  filters: {
    formatNumber0 (d) {
      return StringFormat.nFormat(d, 0, true, 0)
    },
    formatNumber2 (d) {
      return StringFormat.nFormat(d, 2, true, 0)
    }
  }
}
